import { CheckboxEditor, DateTimeEditor, TextEditor } from '@approvalmax/ui';
import { memo, useCallback } from 'react';

import { SectionContainer } from '../../../../../components/SectionContainer';
import { messages } from './ManualJournalHeaderFields.messages';
import { CheckboxWrapper, FieldsWrapper, NarrationField, StyledField } from './ManualJournalHeaderFields.styles';
import { ManualJournalHeaderFieldsProps } from './ManualJournalHeaderFields.types';

const ManualJournalHeaderFields = memo<ManualJournalHeaderFieldsProps>((props) => {
    const { fieldValues, showErrors, onFieldChange } = props;

    const onNarrationChange = useCallback(
        (newValue: string | null) => {
            onFieldChange('narration', newValue);
        },
        [onFieldChange]
    );

    const onDateChange = useCallback(
        (newValue: string | null) => {
            onFieldChange('journalDate', newValue);
        },
        [onFieldChange]
    );

    const onShowOnCashBasisReportsChange = useCallback(
        (newValue: boolean) => {
            onFieldChange('showOnCashBasisReports', newValue);
        },
        [onFieldChange]
    );

    const onDefaultNarrationToDescriptionChange = useCallback(
        (newValue: boolean) => {
            onFieldChange('defaultNarrationToDescription', newValue);
        },
        [onFieldChange]
    );

    return (
        <div>
            <SectionContainer title={null}>
                <FieldsWrapper>
                    <NarrationField title={messages.narration} required>
                        <TextEditor
                            value={fieldValues.narration || ''}
                            onChange={onNarrationChange}
                            placeholder={messages.narrationPlaceholder}
                            maxLength={4000}
                            invalid={showErrors && !fieldValues.narration}
                        />
                    </NarrationField>

                    <StyledField title={messages.journalDate} required>
                        <DateTimeEditor
                            value={fieldValues.journalDate || null}
                            placeholder={messages.journalDatePlaceholder}
                            invalid={showErrors && !fieldValues.journalDate}
                            onChange={onDateChange}
                        />
                    </StyledField>
                </FieldsWrapper>

                <FieldsWrapper>
                    <CheckboxWrapper>
                        <CheckboxEditor
                            value={fieldValues.showOnCashBasisReports}
                            onChange={onShowOnCashBasisReportsChange}
                        />

                        <div>{messages.showOnCashBasisReports}</div>
                    </CheckboxWrapper>

                    <CheckboxWrapper>
                        <CheckboxEditor
                            value={fieldValues.defaultNarrationToDescription}
                            onChange={onDefaultNarrationToDescriptionChange}
                        />

                        <div>{messages.defaultNarration}</div>
                    </CheckboxWrapper>
                </FieldsWrapper>
            </SectionContainer>
        </div>
    );
});

export default ManualJournalHeaderFields;
